import React, {useEffect, useRef, useState} from "react"
import PropTypes from "prop-types"
import {Button, Card, CardBody, Col, Container, Form, Row} from "reactstrap"
import {connect} from "react-redux"
import { useLocation, withRouter } from "react-router-dom"

//Date Picker
import {registerLocale, setDefaultLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import ptBR from "date-fns/locale/pt-BR"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import moment from "moment"
import momentTimezone from "moment-timezone"
import {buscarNotasSituacoes} from "../../store/auth/profile/actions"
import OverView from "./overview"
import CardWelcome from "./card-welcome"
import MiniWidget from "./mini-widget"
import { getDashboardData } from "../../store/dashboard/actions"
import usePermission from "helpers/permission/usePermission"
import NotasTable from "./notas-table"
import {Filters} from "../../common/data/definitions"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"
import FormFilterSelect from "../../components/Common/form-filter-select"
import FormFilterPeriod from "../../components/Common/form-filter-period"
import {
    getCompanies,
    getCompaniesValuesByOptions,
    getCompanyOption,
    getDatasPeloPeriodo, getPeriodos,
    isNotEmpty
} from "../../helpers/utils"
import FormFilterCompany from "../../components/Common/form-filter-company"
import {withTranslation} from "react-i18next";
import { navegarBreadCrumb } from "../../store/navigator/actions"

registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const brazilMoment = (...args) => momentTimezone(...args)

const NotasEmitidas = props => {

    const ref = useRef();

    const [startDate, setStartDate] = useState(
        moment().subtract(30, "days").toDate()
    )
    const [endDate, setEndDate] = useState(new Date())

    const [situation, setSituation] = useState("")
    const [periods, setPeriods] = useState([])
    const [period, setPeriod] = useState(null)
    const [tipoNota, setTipoNota] = useState("")
    const [totalNotas, setTotalNotas] = useState(null)
    const [filters, setFilters] = useState(null)
    const location = useLocation();
    const [companies, setCompanies] = useState([])
    const [companiesOptions, setCompaniesOptions] = useState([])

    const usePermissionListar = usePermission('notasEmitidas_listar')

    const [reports, setReports] = useState([
        {
            id: 'notashoje',
            title: props.t('notasemitidas.lista.notashoje.label'),
            tooltip: props.t('notasemitidas.lista.notashoje.tooltip'),
            icon: "mdi mdi-note-multiple-outline",
            color: "warning",
            value: "",
            desc: "",
            loading: true
        },
        {
            id: 'notasmes',
            title: props.t('notasemitidas.lista.notasmes.label'),
            tooltip: props.t('notasemitidas.lista.notasmes.tooltip'),
            icon: "mdi mdi-note-multiple-outline",
            color: "primary",
            value: "",
            desc: "",
            loading: true
        },
        {
            id: 'notasano',
            title: props.t('notasemitidas.lista.notasano.label'),
            tooltip: props.t('notasemitidas.lista.notasano.tooltip'),
            icon: "mdi mdi-note-multiple-outline",
            color: "info",
            value: "",
            desc: "",
            loading: true
        }
    ])

    const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))

    useEffect(() => {
        const { primeiroPeriodo, tmpPeriods } = getPeriodos()
        setPeriod(primeiroPeriodo)
        setPeriods(tmpPeriods)

        if(props.dashboardFilters.companiesSelected) setCompanies(props.dashboardFilters.companiesSelected)
        if (possuiVinculo) {
            populateFiltros(primeiroPeriodo, props.dashboardFilters.companiesSelected);

            props.buscarNotasSituacoes()
            props.getDashboardData(null, null, props.dashboardFilters.companiesId, "notasSemanas")
            props.getDashboardData(null, null, props.dashboardFilters.companiesId, "notasMeses")
            props.getDashboardData(null, null, props.dashboardFilters.companiesId, "notasAnos")
        }
        props.navegarBreadCrumb({title: `dashboard.lista.notasemitidas.label`, link: location.pathname})
        return () => {
            setPeriods([])
        }
    }, [])

    useEffect( () => {
        if (props.dashboardFilters.companiesSelected) {
            setCompanies(props.dashboardFilters.companiesSelected)
        }
    }, [props.dashboardFilters.companiesSelected])

    useEffect(() => {
        if(props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador && Array.isArray(props.empresas)) {
            let companiesOptions = props.empresas.map(empresa => getCompanyOption(empresa));
            setCompaniesOptions(companiesOptions)
        } else {
            let companiesOptions = getCompanies(props.user)
            setCompaniesOptions(companiesOptions)
        }
        return () => {
            setCompaniesOptions([])
        }
    }, [props.user, props.empresas])

    const describeDiff = (A, B, numberOnly = false) => {
        A = parseFloat(A)
        B = parseFloat(B)

        const diff = A && B ? (100 * Math.abs((B - A) / B)).toFixed(2) : 0

        if (numberOnly) {
            return parseInt(diff)
        }

        return A >= B ? `+ ${diff} %` : `- ${diff} %`
    }

    const abbreviateNumber = (num, fixed) => {
        if (num === null) {
            return null
        } // terminate early
        if (num === 0) {
            return "0"
        } // terminate early
        fixed = !fixed || fixed < 0 ? 0 : fixed // number of decimal places to show
        var b = num.toPrecision(2).split("e"), // get power
            k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            c =
                k < 1
                    ? num.toFixed(0 + fixed)
                    : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
            d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
            e = d + ["", "K", "M", "B", "T"][k] // append power
        return e
    }

    const weekdayName = dia_numerico => {
        return [
            "Segunda",
            "Terça",
            "Quarta",
            "Quinta",
            "Sexta",
            "Sábado",
            "Domingo"
        ][dia_numerico]
    }

    const monthName = month => {
        return [
            null,
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez"
        ][month]
    }

    useEffect(() => {
        setReports([
            {
                id: 'notashoje',
                title: props.t('notasemitidas.lista.notashoje.label'),
                tooltip: props.t('notasemitidas.lista.notashoje.tooltip'),
                icon: "mdi mdi-note-multiple-outline",
                color: "warning",
                value:
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo &&
                    Array.isArray(props.dashboardNotasSemanas.periodo) &&
                    props.dashboardNotasSemanas.periodo.length
                        ? parseFloat(
                            props.dashboardNotasSemanas.periodo[0][0].total_nf || 0
                        ).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : 0,
                desc: describeDiff(
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo &&
                        Array.isArray(props.dashboardNotasSemanas.periodo) &&
                        props.dashboardNotasSemanas.periodo.length
                        ? props.dashboardNotasSemanas.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasSemanas &&
                        props.dashboardNotasSemanas.periodo_anterior &&
                        Array.isArray(props.dashboardNotasSemanas.periodo_anterior) &&
                        props.dashboardNotasSemanas.periodo_anterior.length
                        ? props.dashboardNotasSemanas.periodo_anterior[0][0].total_nf || 0
                        : 0
                ),
                loading: props.loadingDashboardNotasSemanas,
                series: [
                    {
                        name: "Valor",
                        data:
                            props.dashboardNotasSemanas && props.dashboardNotasSemanas.semana &&
                            Array.isArray(props.dashboardNotasSemanas.semana) &&
                            props.dashboardNotasSemanas.semana.length
                                ? props.dashboardNotasSemanas.semana[0].map(e => e.total_nf)
                                : []
                    }
                ],
                diff: describeDiff(
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo &&
                        Array.isArray(props.dashboardNotasSemanas.periodo) &&
                        props.dashboardNotasSemanas.periodo.length
                        ? props.dashboardNotasSemanas.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo_anterior &&
                        Array.isArray(props.dashboardNotasSemanas.periodo_anterior) &&
                        props.dashboardNotasSemanas.periodo_anterior.length
                        ? props.dashboardNotasSemanas.periodo_anterior[0][0].total_nf || 0
                        : 0,
                    true
                ),
                options: {
                    chart: {sparkline: {enabled: !0}},
                    stroke: {curve: "smooth", width: 2},
                    colors: ["#f1b44c"],
                    fill: {
                        type: "gradient",
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: !1,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [25, 100, 100, 100]
                        }
                    },
                    tooltip: {
                        fixed: {enabled: !1},
                        x: {show: !1},
                        marker: {show: !1}
                    },
                    yaxis: {
                        labels: {
                            formatter: function (val, object) {
                                if (object) {
                                    return (
                                        weekdayName(
                                            Array.isArray(props.dashboardNotasSemanas) && props.dashboardNotasSemanas.length ?
                                                props.dashboardNotasSemanas.semana[0][object.dataPointIndex].weekday : 0) +
                                        " " +
                                        abbreviateNumber(val)
                                    )
                                }
                            }
                        }
                    }
                }
            },
            {
                id: 'notasmes',
                title: props.t('notasemitidas.lista.notasmes.label', { data: (brazilMoment(props.currentPeriod).format(
                    "MMM"
                ))}),
                tooltip: props.t('notasemitidas.lista.notasmes.tooltip'),
                icon: "mdi mdi-note-multiple-outline",
                color: "primary",
                value:
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo)
                        ? parseFloat(
                            props.dashboardNotasMeses.periodo[0][0].total_nf || 0
                        ).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : 0,
                desc: describeDiff(
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo)
                        ? props.dashboardNotasMeses.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo_anterior)
                        ? props.dashboardNotasMeses.periodo_anterior[0][0].total_nf || 0
                        : 0
                ),
                loading: props.loadingDashboardNotasMeses,
                series: [
                    {
                        name: "Valor",
                        data:
                            props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.meses)
                                ? props.dashboardNotasMeses.meses[0].map(e => e.total_nf)
                                : []
                    }
                ],
                diff: describeDiff(
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo)
                        ? props.dashboardNotasMeses.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo_anterior)
                        ? props.dashboardNotasMeses.periodo_anterior[0][0].total_nf || 0
                        : 0,
                    true
                ),
                options: {
                    chart: {sparkline: {enabled: !0}},
                    stroke: {curve: "smooth", width: 2},
                    colors: ["#f1b44c"],
                    fill: {
                        type: "gradient",
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: !1,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [25, 100, 100, 100]
                        }
                    },
                    tooltip: {
                        fixed: {enabled: !1},
                        x: {show: !1},
                        marker: {show: !1}
                    },
                    yaxis: {
                        labels: {
                            formatter: function (val, object) {
                                if (object) {
                                    return (
                                        monthName(Array.isArray(props.dashboardNotasMeses) && props.dashboardNotasMeses.length ?
                                          props.dashboardNotasMeses.meses[0][object.dataPointIndex].month : 0
                                        ) +
                                        " " +
                                        abbreviateNumber(val)
                                    )
                                }
                            }
                        }
                    }
                }
            },
            {
                id: 'notasano',
                title: props.t('notasemitidas.lista.notasano.label', { data: (brazilMoment(props.currentPeriod).format(
                        "YY"
                    ))}),
                tooltip: props.t('notasemitidas.lista.notasano.tooltip'),
                icon: "mdi mdi-note-multiple-outline",
                color: "info",
                value:
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo)
                        ? parseFloat(
                            props.dashboardNotasAnos.periodo[0][0].total_nf || 0
                        ).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : 0,
                desc: describeDiff(
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo)
                        ? props.dashboardNotasAnos.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo_anterior)
                        ? props.dashboardNotasAnos.periodo_anterior[0][0].total_nf || 0
                        : 0
                ),
                loading: props.loadingDashboardNotasAnos,
                series: [
                    {
                        name: "Valor",
                        data:
                            props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.meses)
                                ? props.dashboardNotasAnos.meses[0].map(e => e.total_nf)
                                : []
                    }
                ],
                diff: describeDiff(
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo)
                        ? props.dashboardNotasAnos.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo_anterior)
                        ? props.dashboardNotasAnos.periodo_anterior[0][0].total_nf || 0
                        : 0,
                    true
                ),
                options: {
                    chart: {sparkline: {enabled: !0}},
                    stroke: {curve: "smooth", width: 2},
                    colors: ["#f1b44c"],
                    fill: {
                        type: "gradient",
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: !1,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [25, 100, 100, 100]
                        }
                    },
                    tooltip: {
                        fixed: {enabled: !1},
                        x: {show: !1},
                        marker: {show: !1}
                    },
                    yaxis: {
                        labels: {
                            formatter: function (val, object) {
                                if (object) {
                                    return (
                                        monthName(Array.isArray(props.dashboardNotasMeses) && props.dashboardNotasMeses.length ?
                                          props.dashboardNotasMeses.meses[0][object.dataPointIndex].month : 0
                                        ) +
                                        " " +
                                        abbreviateNumber(val)
                                    )
                                }
                            }
                        }
                    }
                }
            }
        ])

        return () => setReports([])
    }, [
        props.dashboardNotasSemanas,
        props.dashboardNotasMeses,
        props.dashboardNotasAnos
    ])

    const populateFiltros = (periodoSelecionado, companiesSelected) => {
        const filters = [{id: 'nf', value: 0, condition: Filters.greaterThan}]

        if (companiesSelected) {
            filters.push({id: 'idEmpresa', value: getCompaniesValuesByOptions(companiesSelected) })
        } else if (companies) {
            filters.push({id: 'idEmpresa', value: getCompaniesValuesByOptions(companies) })
        }

        if (situation) filters.push({id: 'status', value: situation})
        if (tipoNota) filters.push({id: 'tipo_nf', value: tipoNota})

        let periodo = period || periodoSelecionado
        let datasPeloPeriodo = getDatasPeloPeriodo(periodo, startDate, endDate)
        if(datasPeloPeriodo) {
            filters.push({id: 'data_emissao', value: datasPeloPeriodo.inicio, condition: Filters.greaterThanOrEqualTo})
            filters.push({id: 'data_emissao', value: datasPeloPeriodo.fim, condition: Filters.lessThanOrEqualTo})
        }

        setFilters(filters)
    }

    const pesquisar = () => {
        populateFiltros();
        setTimeout(() => ref?.current?.search(), 300)
    }

    const onPickStartDate = date => {
        setStartDate(date)
        setEndDate(date)
    }

    if (
        !props.user ||
        !props.user.vinculos.length ||
        !(props.user.vinculos || []).filter(e =>
            ["A", "T"].find(status => status == e.vinculo_status)
        ).length
    ) {
        return (
            <AlertaSemVinculo/>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="dashboard.lista.notasemitidas.label"/>

                    <Row>
                        <Col lg="12">
                            <div>
                                <Row>
                                    <OverView company={companies} />

                                    <Col xl="8">
                                        <CardWelcome/>

                                        <Row>
                                            <MiniWidget reports={reports}/>
                                        </Row>
                                    </Col>
                                </Row>

                                <Card>
                                    <CardBody>
                                        <h4 className="card-title mb-3">Notas Emitidas</h4>

                                        <Form>
                                            <Row>
                                                <div className="col-xl col-sm-6">
                                                    <FormFilterCompany
                                                        attribute="companies"
                                                        value={companies}
                                                        description="Empresa(s)"
                                                        setValue={ value => setCompanies(value) }
                                                        options={companiesOptions}
                                                        multiple={ true }
                                                        hasSelectAll={ !(props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador) }
                                                    />
                                                </div>

                                                <FormFilterPeriod
                                                    periodValue={period}
                                                    periodChangeHandeler={e => setPeriod(e)}
                                                    options={periods}
                                                    startDateValue={startDate}
                                                    startDateChangeHandeler={e => onPickStartDate(e)}
                                                    endDateValue={endDate}
                                                    endDateChangeHandeler={e => setEndDate(e)}
                                                    t={props.t}
                                                />

                                                <div className="col-xl col-sm-6">
                                                    <FormFilterSelect
                                                        attribute="situacao"
                                                        value={situation}
                                                        description="Situação"
                                                        changeHandeler={ value => setSituation(value) }
                                                        options={ [{ value: ""  , label: "Qualquer", defaultValue: true },
                                                            ...(Array.isArray(props.notasSituacoes) ? props.notasSituacoes : []) ] }
                                                    />
                                                </div>
                                                <div className="col-xl col-sm-6">
                                                    <FormFilterSelect
                                                        attribute="tipoNota}"
                                                        value={tipoNota}
                                                        description="Entrada/Saída"
                                                        changeHandeler={ value => setTipoNota(value) }
                                                        options={ [
                                                            { value: "", label: "Qualquer", defaultValue: true },
                                                            { value: "0", label: "Entrada" },
                                                            { value: "1", label: "Saída" },
                                                        ] }
                                                    />
                                                </div>

                                                <div className="col-xl col-sm-6 align-self-start mt-4 pt-1">
                                                    <div className="mt-3">
                                                        <Button color="primary" className="w-md" onClick={e => pesquisar()}
                                                                disabled={!usePermissionListar}>
                                                            Buscar
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>

                                { filters && <Card>
                                    <CardBody>
                                        <NotasTable ref={ref} filters={filters} usePermissionListar={usePermissionListar}>
                                        </NotasTable>
                                    </CardBody>
                                </Card> }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

NotasEmitidas.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func
}

const mapStatetoProps = state => {
    const {notasSituacoes, notas, empresas, empresasLoading} = state.Profile

    const {
      loadingDashboardNotasSemanas,
      dashboardNotasSemanas,
      loadingDashboardNotasMeses,
      dashboardNotasMeses,
      loadingDashboardNotasAnos,
      dashboardNotasAnos,
    } = state.Dashboard

    const {
        user,
        currentPeriod,
        dashboardFilters
    } = state.Login
    return {
        notasSituacoes,
        notas,
        user,
        loadingDashboardNotasSemanas,
        dashboardNotasSemanas,
        loadingDashboardNotasMeses,
        dashboardNotasMeses,
        loadingDashboardNotasAnos,
        dashboardNotasAnos,
        currentPeriod, dashboardFilters,
        empresas,
        empresasLoading
    }
}

export default withTranslation()(connect(mapStatetoProps, {
    buscarNotasSituacoes,
    getDashboardData, navegarBreadCrumb
})(withRouter(NotasEmitidas)))
